exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TextAreaField-hashed__textArea__2AZ2v{--textArea-min-height: calc(3 * var(--GW-INPUT-LINE-HEIGHT) * 16px + 2 * calc(var(--GW-INPUT-PADDING-Y) + var(--GW-INPUT-BORDER-WIDTH)));min-height:var(--textArea-min-height);resize:vertical;height:auto;white-space:pre-wrap}.TextAreaField-hashed__textAreaReadOnly__2SY9-{white-space:pre-wrap;height:auto}\n", ""]);

// exports
exports.locals = {
	"textArea": "TextAreaField-hashed__textArea__2AZ2v",
	"textAreaReadOnly": "TextAreaField-hashed__textAreaReadOnly__2SY9-"
};